module.exports = "/lucky-balls/img/drawnballs/blue.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drawnballs/blue.png
// module id = 1009
// module chunks = 0